import {inject, injectable} from 'inversify';

import {CachedMediaFactory} from '../../../core/models/CachedMedia/CachedMedia.factory';
import {RemoteFileStorageService} from '../../../core/system/remoteFileStorage/RemoteFileStorage.service';
import {ImageModel} from './Image.model';

@injectable()
export class ImageModelFactory {
  constructor(
    @inject(CachedMediaFactory)
    private readonly cachedMediaFactory: CachedMediaFactory,
    @inject(RemoteFileStorageService)
    private readonly remoteFileStorageService: RemoteFileStorageService,
  ) {}

  create() {
    return new ImageModel(
      this.cachedMediaFactory,
      this.remoteFileStorageService,
    );
  }
}
